export interface ApiErrorBody {
  ok: false;
  error: {
    code: number;
    message: string;
    reason?: string;
    required?: string[];
  };
}

export interface ApiSuccessBody<T> {
  ok: true;
  data: T;
  meta?: Record<string, unknown>;
}

export type ApiResponse<T> = ApiSuccessBody<T> | ApiErrorBody;

export function isApiError<T>(res: ApiResponse<T>): res is ApiErrorBody {
  return res.ok === false;
}

export class ApiClientError extends Error {
  readonly status: number;
  readonly code: number;
  readonly reason?: string;
  readonly paywall?: unknown;

  constructor(
    message: string,
    status: number,
    code: number,
    reason?: string,
    paywall?: unknown,
  ) {
    super(message);
    this.name = "ApiClientError";
    this.status = status;
    this.code = code;
    this.reason = reason;
    this.paywall = paywall;
  }
}
